import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuetify from "vuetify";
import * as Sentry from "@sentry/vue";

Vue.config.productionTip = false;

Vue.use(Vuetify);

if (
    process.env.VUE_APP_SENTRY_ENVIRONMENT &&
    process.env.VUE_APP_SENTRY_DSN &&
    process.env.VUE_APP_SENTRY_ENVIRONMENT_WHITELIST &&
    process.env.VUE_APP_SENTRY_ENVIRONMENT_WHITELIST.split(",").includes(
        process.env.VUE_APP_SENTRY_ENVIRONMENT
    )
) {
    Sentry.init({
        Vue,
        dsn: process.env.VUE_APP_SENTRY_DSN,
        environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
        ignoreErrors: [
            "NavigationDuplicated",
        ],
    });
}

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount("#app");
